import { useCallback, useEffect, useState } from 'react';
import { peerScoreDetailStudent } from './peerReviewDetailData';

// 互评恶意打分人工修正状态
// 说明：互评任务管理、恶意打分记录两个页面共用这里的状态，避免两个页面各自保存导致结果不一致。
const STORAGE_KEY = 'csEvaluation.peerReviewCorrectionMap';
const CORRECTION_EVENT = 'csEvaluationPeerReviewCorrectionChange';

function readCorrectionMap() {
  if (typeof window === 'undefined') {
    return {};
  }

  try {
    const cache = window.localStorage.getItem(STORAGE_KEY);
    return cache ? JSON.parse(cache) : {};
  } catch (error) {
    return {};
  }
}

function getSavedMaliciousStatus(studentId, defaultStatus) {
  const correctionMap = readCorrectionMap();
  const savedRecord = correctionMap[studentId];

  if (typeof savedRecord?.isMalicious === 'boolean') {
    return savedRecord.isMalicious;
  }

  return defaultStatus;
}

function saveMaliciousStatus(studentId, isMalicious) {
  if (typeof window === 'undefined') {
    return;
  }

  const correctionMap = readCorrectionMap();
  const nextCorrectionMap = {
    ...correctionMap,
    [studentId]: {
      isMalicious,
      updatedAt: new Date().toISOString(),
    },
  };

  window.localStorage.setItem(STORAGE_KEY, JSON.stringify(nextCorrectionMap));
  window.dispatchEvent(
    new CustomEvent(CORRECTION_EVENT, {
      detail: {
        studentId,
        isMalicious,
      },
    })
  );
}

export function usePeerReviewCorrection(
  studentId = peerScoreDetailStudent.studentId,
  defaultStatus = peerScoreDetailStudent.isMalicious
) {
  const [isMalicious, setIsMalicious] = useState(() =>
    getSavedMaliciousStatus(studentId, defaultStatus)
  );

  const updateMaliciousStatus = useCallback(
    (nextStatus) => {
      setIsMalicious(nextStatus);
      saveMaliciousStatus(studentId, nextStatus);
    },
    [studentId]
  );

  useEffect(() => {
    function syncFromStorage() {
      setIsMalicious(getSavedMaliciousStatus(studentId, defaultStatus));
    }

    function syncFromCurrentPage(event) {
      if (event.detail?.studentId !== studentId) {
        return;
      }

      setIsMalicious(event.detail.isMalicious);
    }

    window.addEventListener('storage', syncFromStorage);
    window.addEventListener(CORRECTION_EVENT, syncFromCurrentPage);

    return () => {
      window.removeEventListener('storage', syncFromStorage);
      window.removeEventListener(CORRECTION_EVENT, syncFromCurrentPage);
    };
  }, [studentId, defaultStatus]);

  return [isMalicious, updateMaliciousStatus];
}
